import { findContentfulFlagValue } from 'components/PageSections/utils';
import { PricingCardProps } from 'components/PricingCard';

import { PricingSelectorProps } from './PricingSelector';

// TODO Update contentfulSection type
export const parsePricingSelectorData = (
  contentfulSection: any,
  selectedOptionCallback?: (option: PricingCardProps) => void,
): PricingSelectorProps | null => {
  const {
    displayName,
    subsections,
    metadata: { title, ctas, metadata_id, context, flags },
    modal,
  } = contentfulSection;

  // Validate that all sections are added in Contentful
  if (!displayName && !subsections && !title && !ctas) {
    return null;
  }

  const options =
    subsections &&
    subsections.map((subsection: any) => {
      const perks = subsection?.subsections?.map((sub: any) => ({
        title: sub.displayName,
        isHighlighted: sub.metadata?.flags?.[0]?.value || false,
      }));

      return {
        period: subsection.displayName,
        description: subsection.body,
        // Contentful returns the redirection link hardcoded to an specific environment, so we need to replace it
        url: subsection?.metadata?.context?.url,
        price: {
          value: subsection?.metadata?.context?.price?.value,
          discount: subsection?.metadata?.context?.price?.discount,
          frequency: subsection?.metadata?.context?.price?.frequency,
        },
        isStatic: subsection?.metadata?.context?.pricing_card_is_static,
        perks: perks,
        isInvalid: findContentfulFlagValue(
          'isInvalidOption',
          subsection?.metadata?.flags,
        ),
      };
    });

  const CTALabel =
    ctas?.[0]?.label ||
    //@Deprecated, remove after all contentful sections are updated
    ctas[0].displayName;

  const isJustunoTrigger = findContentfulFlagValue(
    'isJustunoTrigger',
    ctas?.[0]?.metadata?.flags,
  );
  const ctaClassName = ctas?.[0]?.metadata?.metadata_id ?? '';

  const pricingSelectorProps: PricingSelectorProps = {
    eyebrow: displayName,
    title: title,
    options: options,
    CTALabel,
    CTAUrl: ctas?.[0]?.url,
    overrideCTAProps: {
      ...(isJustunoTrigger && { as: 'button', role: 'button' }),
      ...(ctaClassName && { className: ctaClassName }),
    },
    sectionId: metadata_id ? metadata_id : null,
    selectedOptionCallback,
    disclaimer: context?.pricing_disclaimer,
    hasExperimentModal: findContentfulFlagValue('hasExperimentModal', flags),
    modal:
      modal?.componentName === 'PricingSelectorModal'
        ? modal
        : {
            title: modal?.content?.[0]?.metadata?.title,
            description:
              modal?.content?.[0]?.metadata?.description?.description,
            cta: modal?.content?.[0]?.metadata?.ctas?.[0],
            isExperimentModal: true,
          },
  };

  return pricingSelectorProps;
};
